<template>

    <form method="get" :action="route('search.index')" class="w-100 mt-3 mt-lg-0">
        <div class="input-group input-group-lg border border-primary border-2 search-input-group">
            <input name="search"
                   required
                   class="form-control search-input autocomplete-input"
                   type="search"
                   v-model="searchQuery"
                   placeholder="Suche"
                   autocomplete="off" />
            <autocomplete :search-query="searchQuery" />
            <button class="btn search-submit" type="submit"><i class="bi bi-search"></i></button>
        </div>
    </form>

</template>

<script>
    import Autocomplete from '@/shared/Autocomplete';

    export default {
        props: [
            'search'
        ],
        data() {
            return {
                searchQuery: this.$page.props.searchQuery,
            }
        },
        components: {
            Autocomplete,
        }
    }
</script>